import { render, staticRenderFns } from "./qualitydata.vue?vue&type=template&id=161211eb&scoped=true"
import script from "./qualitydata.vue?vue&type=script&lang=js"
export * from "./qualitydata.vue?vue&type=script&lang=js"
import style0 from "./qualitydata.vue?vue&type=style&index=0&id=161211eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161211eb",
  null
  
)

export default component.exports